// extracted by mini-css-extract-plugin
export default {"item":"SidebarItem_item__6Jg8i","item--selected":"SidebarItem_item--selected__jN0+S","item__icon":"SidebarItem_item__icon__Lh5r8","item__text":"SidebarItem_item__text__xhlIG"};